import { Users, Trophy, Clock, ThumbsUp } from 'lucide-react';
import { Reveal } from './motion/Reveal';

export const TrustStats = () => {
  const stats = [
    {
      icon: Users,
      value: '8.500+',
      label: 'Trabalhadores atendidos',
    },
    {
      icon: Trophy,
      value: 'R$ 28M+',
      label: 'Recuperados em indenizações',
    },
    {
      icon: Clock,
      value: '97%',
      label: 'Taxa de sucesso e acordos',
    },
    {
      icon: ThumbsUp,
      value: '4.9/5',
      label: 'Nota de satisfação',
    },
  ];

  return (
    <section
      data-testid="trust-stats-section"
      className="py-16 bg-white"
    >
      <Reveal className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-blue-900 rounded-3xl py-12 px-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div
                key={index}
                data-testid={`stat-${index}`}
                className="text-center"
              >
                <div className="inline-flex items-center justify-center w-12 h-12 bg-blue-800 rounded-xl mb-4">
                  <stat.icon className="w-6 h-6 text-yellow-400" />
                </div>
                <p className="text-3xl md:text-4xl font-bold text-yellow-400 mb-1">
                  {stat.value}
                </p>
                <p className="text-blue-200 font-medium text-sm">
                  {stat.label}
                </p>
              </div>
            ))}
          </div>
        </div>
      </Reveal>
    </section>
  );
};
